import React from "react"
import { Button, Col, Row } from "react-bootstrap"
import BootstrapTable, { ColumnDescription } from "react-bootstrap-table-next"
import filterFactory from "react-bootstrap-table2-filter"
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit"
import { useTranslation } from "react-i18next"
import shortId from "shortid"
import { useAppDispatch } from "../../app/hooks"
import { SearchBar } from "../../components/Tables/Columns"
import { SHOPINI_ECONOMY } from "../../constants/constants"
import { setConsolBox } from "../../store/consolidation.store"

function DispatchTable({
    economyconsols,
    setSelectedRow,
    setShow
}: {
    economyconsols: Record<string, any>[]
    setSelectedRow: Function
    setShow: Function
}) {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const printMenifest = () => {
        // handleBtnClick();
    }
    const columns = [
        // {
        // 	dataField: "id",
        // 	text: t("#"),
        // },
        {
            text: t("Consolidation"),
            dataField: "uuid",
            classes: "highlighted-text"
        }
    ]

    const { ExportCSVButton } = CSVExport

    return (
        <div className="table-responsive">
            {columns && (
                <ToolkitProvider
                    keyField="uuid"
                    data={economyconsols}
                    columns={columns as ColumnDescription<any, any>[]}
                    search={{ searchFormatted: true }}
                    exportCSV={{
                        fileName: "economyconsolsTable.csv",
                        noAutoBOM: false,
                        exportAll: false,
                        onlyExportFiltered: true
                    }}>
                    {(props) => (
                        <div className="table-container my-4">
                            <Row className="search suites-search">
                                <Col xs={12} sm={12} md={12} lg={12} className="d-flex justify-content-end">
                                    <SearchBar {...props.searchProps} />
                                    <ExportCSVButton
                                        {...props.csvProps}
                                        className=" economyconsolsExportButton d-none">
                                        Export
                                    </ExportCSVButton>
                                    <Button
                                        variant="primary"
                                        type="submit"
                                        className="ml-2 col-lg-1 col-md-2 col-sm-4"
                                        onClick={() => {
                                            dispatch(
                                                setConsolBox({
                                                    shippingService: SHOPINI_ECONOMY,
                                                    uuid: shortId.generate(),
                                                    Children: [...economyconsols]
                                                })
                                            )
                                            setShow("consolidate")
                                        }}>
                                        {t("view")}
                                    </Button>
                                </Col>
                            </Row>

                            <Row className="table-data my-3">
                                <Col>
                                    <BootstrapTable
                                        {...props.baseProps}
                                        wrapperClasses="table-wrapper my-3 "
                                        headerClasses="header-class"
                                        bordered={false}
                                        noDataIndication={t("No_Record")}
                                        filter={filterFactory()}
                                        rowClasses="custom-table-row"
                                        condensed={true}
                                        // selectRow={ selectRow }
                                    />
                                </Col>
                            </Row>
                            {/* <Row className="mt-4 mx-1">
									<Col xs={12} sm={12} md={12} lg={12} className="text-align-end ">
										<Button variant="primary" type="submit" className="w-15" onClick={() => printMenifest()}>
											{t("Print_Manifest")}
										</Button>
									</Col>
								</Row> */}
                        </div>
                    )}
                </ToolkitProvider>
            )}
        </div>
    )
}

export default DispatchTable
